var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProtec(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 73.3 81.5",
    style: {
      enableBackground: "new 0 0 73.3 81.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#4C54F3;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_985",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71,5.2H3c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2v-68C73,6.1,72.1,5.2,71,5.2z M70,74.2H4 v-66h66V74.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71,5.2H3c-1.1,0-2,0.9-2,2v68c0,1.1,0.9,2,2,2h68c1.1,0,2-0.9,2-2v-68C73,6.1,72.1,5.2,71,5.2z M70,74.2H4 v-66h66V74.2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Trac\\xE9_1315_2_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 36.1,
    y: 30.6,
    className: "st2",
    width: 1.6,
    height: 26.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.1,23.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.3-0.2-0.5-0.3c-0.1,0-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0-0.3,0H17.8c-0.4,0-0.8,0.2-1.1,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4v23.7 C22.7,59,35.9,63.1,37.2,63.5c1.4-0.4,14.6-4.5,20.9-15.9V23.9C58.1,23.8,58.1,23.7,58.1,23.6z M56,46.9c0,0.1,0,0.2-0.1,0.2 c-5.4,9.2-15.6,13.1-18.6,14.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-1.3-0.4-3.9-1.4-6.9-3.1c-2.4-1.4-4.6-2.9-6.5-4.7 c-2.1-1.9-3.9-4.1-5.2-6.4c0-0.1-0.1-0.2-0.1-0.2V25.1c0-0.2,0.2-0.4,0.4-0.4h36.7c0.3,0,0.4,0.2,0.4,0.4V46.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.1,23.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.3-0.2-0.5-0.3c-0.1,0-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0-0.3,0H17.8c-0.4,0-0.8,0.2-1.1,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.4c0,0.1-0.1,0.3-0.1,0.4v23.7 C22.7,59,35.9,63.1,37.2,63.5c1.4-0.4,14.6-4.5,20.9-15.9V23.9C58.1,23.8,58.1,23.7,58.1,23.6z M56,46.9c0,0.1,0,0.2-0.1,0.2 c-5.4,9.2-15.6,13.1-18.6,14.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-1.3-0.4-3.9-1.4-6.9-3.1c-2.4-1.4-4.6-2.9-6.5-4.7 c-2.1-1.9-3.9-4.1-5.2-6.4c0-0.1-0.1-0.2-0.1-0.2V25.1c0-0.2,0.2-0.4,0.4-0.4h36.7c0.3,0,0.4,0.2,0.4,0.4V46.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtec);
export default __webpack_public_path__ + "static/media/_icon_protec.f66d68830c350e1a924a4c6c067e68d5.svg";
export { ForwardRef as ReactComponent };